import { Controller } from "@hotwired/stimulus"

// Positionne un popover natif (attribut popover) près de son bouton déclencheur.
// L'API native gère le top layer (échappe au clipping de backdrop-filter), la
// fermeture Échap / clic-extérieur et l'accessibilité ; ce controller ne fait
// que le placement quand le popover s'ouvre.
export default class extends Controller {
  static values = { gap: { type: Number, default: 8 } }

  connect() {
    this.boundToggle = this.onToggle.bind(this)
    this.element.addEventListener("toggle", this.boundToggle)
  }

  disconnect() {
    this.element.removeEventListener("toggle", this.boundToggle)
  }

  onToggle(event) {
    if (event.newState !== "open") return
    this.positionNearTrigger()
  }

  positionNearTrigger() {
    const trigger = document.querySelector(`[popovertarget="${this.element.id}"]`)
    if (!trigger) return

    const triggerRect = trigger.getBoundingClientRect()
    const panelRect = this.element.getBoundingClientRect()
    const gap = this.gapValue
    const viewportWidth = window.innerWidth
    const viewportHeight = window.innerHeight

    // Sous le bouton par défaut ; au-dessus si pas assez de place en bas.
    let top = triggerRect.bottom + gap
    const overflowsBottom = top + panelRect.height > viewportHeight
    const fitsAbove = triggerRect.top - panelRect.height - gap > 0
    if (overflowsBottom && fitsAbove) {
      top = triggerRect.top - panelRect.height - gap
    }

    // Aligné au bord gauche du bouton, recadré dans le viewport.
    let left = triggerRect.left
    if (left + panelRect.width > viewportWidth - gap) {
      left = viewportWidth - panelRect.width - gap
    }
    if (left < gap) left = gap

    this.element.style.setProperty("position", "fixed")
    this.element.style.setProperty("margin", "0")
    this.element.style.setProperty("inset", "auto")
    this.element.style.setProperty("top", `${top}px`)
    this.element.style.setProperty("left", `${left}px`)
  }
}
